import { Injectable } from "@angular/core";
import { Http, Response } from "@angular/http";
import { Observable } from "rxjs/Observable";
import "rxjs/add/operator/map";
import "rxjs/add/operator/do";
import "rxjs/add/operator/catch";
import { AdalHttp } from '../../services/adal.http.service';

@Injectable()
export class SystemServicesManager {
    constructor(private http: AdalHttp) {
    }
    
    registerSystemService(systemServiceId: string): Observable<any> {

        var url = `/api/systemservice/${systemServiceId}/add`;
        return this.http.post(url,null)
            .catch((error: any) => {
                return Observable.throw(error);
            });
    }

    deregisterSystemService(systemServiceId: string): Observable<any> {

        var url = `/api/systemservice/${systemServiceId}/remove`;
        return this.http.delete(url, null)
            .catch((error: any) => {
                return Observable.throw(error);
            });
    }

    enableSystemService(systemServiceId: string,systemType:string): Observable<any> {

        var url = `/api/systemservice/${systemServiceId}/enable/systemtype/${systemType}`;
        return this.http.post(url, null)
            .catch((error: any) => {
                return Observable.throw(error);
            });
    }

    disableSystemService(systemServiceId: string, systemType: string): Observable<any> {

        var url = `/api/systemservice/${systemServiceId}/disable/systemtype/${systemType}`;
        return this.http.delete(url, null)
            .catch((error: any) => {
                return Observable.throw(error);
            });
    }

    getSystemTypes(systemServiceId: string): Observable<any> {

        var url = `/api/systemservice/${systemServiceId}/details`;
        return this.http.get(url, null)
            .catch((error: any) => {
                return Observable.throw(error);
            });
    }

    getSystemServiceStatus(systemServiceId: string, systemType: string): Observable<any> {

        var url = `/api/systemservice/${systemServiceId}/status/systemtype/${systemType}`;
        return this.http.get(url, null)
            .catch((error: any) => {
                return Observable.throw(error);
            });
    }
}


/** WEBPACK FOOTER **
 ** ./F:/actions-runner/_work/scpbuildinig_sentience.portal.devops/scpbuildinig_sentience.portal.devops/src/Production/Portal/Cloud.Platform.Global.Portal.DevOps.Web/app/main/SystemServicesManager/system-service.service.ts
 **/